<p-avatar 
    :image="user.photo_thum" 
    :icon="!user.photo_thum ?  'pi pi-user' : ''" 
    shape="circle" 
    style="background-color: #2196f3; color: #ffffff"

    type="button" 
    @click="toggle" 
    aria-haspopup="true"
    aria-controls="overlay_menu"
>
</p-avatar>

<p-menu class="md:w-15rem" ref="menu" id="overlay_menu" :model="items" :popup="true" >
    <!------------------------------------------------------------>
    <template #start>
        <div class="flex flex-column">
            <div class="flex align-items-center justify-content-center">
                <p-avatar 
                    :image="user.photo_thum" 
                    :icon="!user.photo_thum ?  'pi pi-user' : ''" 
                    shape="circle" 
                    style="background-color: #2196f3; color: #ffffff"
                    size="xlarge"
                >
                </p-avatar>
            </div>
            <div class="flex align-items-center justify-content-center font-bold p-2">
                {{user.name}}
            </div>
            <div class="flex align-items-center justify-content-center">
                <i>{{user.email}}</i>
            </div>
        </div>
    </template>
    <!------------------------------------------------------------>

    <!------------------------------------------------------------>
    <template #submenuheader="{ item }">
        <span class="text-primary font-bold">{{ item.label }}</span>
    </template>
    <!------------------------------------------------------------>

    <!------------------------------------------------------------>
    <template #item="{ item, props }">
        <router-link :to="item.to ?  item.to : ''" v-ripple class="flex align-items-center" v-bind="props.action" >
            <font-awesome-icon :icon="item.icon" />
            <span class="ml-2">{{ item.label }}</span>
            <p-badge v-if="item.badge" class="ml-auto" :value="item.badge" />
            <span v-if="item.shortcut" class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{{ item.shortcut }}</span>
        </router-link>
    </template>
    <!------------------------------------------------------------>

    <!------------------------------------------------------------>
    <template #end>
        <div class="flex align-items-center justify-content-center">
            <div class="flex align-items-center justify-content-center mr-2">
                <p-button :disabled="is_loading" :icon="is_loading ? 'pi pi-spin pi-cog' : (checkDark ? 'pi pi-moon':'pi pi-sun')" @click="changeDark" rounded outlined />
            </div>
            <div class="flex align-items-center justify-content-center mr-2">
                <p-button :disabled="is_loading" :icon="is_loading ? 'pi pi-spin pi-cog' : (checkMode === 'static' ? 'pi pi-list':'pi pi-stop')" @click="changeMode" rounded outlined />
            </div>
        </div>
        <hr>
        <p-button @click="onLogout" label="LOGOUT" icon="pi pi-sign-out" severity="danger" class="w-full flex align-items-center" />
    </template>
    <!------------------------------------------------------------>

</p-menu>